import CrmListingSearchInput from 'framework-listing-lib/internal/FilterBar/components/CrmListingSearchInput';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { useHasFoldersTab } from 'framework-listing-lib/internal/Folders/hooks/useFolderProps';
import { useIsListMode, useIsGalleryMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { TABLE_TOP_BAR_HEIGHT } from 'framework-listing-lib/constants/sizes';
import { useHasSearchInput } from 'framework-listing-lib/internal/hooks/useSearchInputProps';
import TableUIModeSelect from './TableUIModeSelect';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FlexFull = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  flex: "1",
  gap: "250",
  alignItems: "center",
  children: children
});
export default function TableTopBar({
  actionsComponent,
  middleSlot,
  isLoading
}) {
  const hasFoldersTab = useHasFoldersTab();
  const isListMode = useIsListMode();
  const isGalleryMode = useIsGalleryMode();
  const hasSearchInput = useHasSearchInput();
  const content = isLoading ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
      blockSize: "32px",
      inlineSize: "250px"
    }), /*#__PURE__*/_jsxs(FlexFull, {
      children: [/*#__PURE__*/_jsx(FlexFull, {}), /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "16px",
        inlineSize: "100px"
      })]
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasSearchInput && /*#__PURE__*/_jsx(CrmListingSearchInput, {}), /*#__PURE__*/_jsxs(FlexFull, {
      children: [/*#__PURE__*/_jsx(FlexFull, {
        children: middleSlot
      }), /*#__PURE__*/_jsx(TableUIModeSelect, {}), actionsComponent]
    })]
  });
  return /*#__PURE__*/_jsx(View, Object.assign({
    "data-test-id": `crm-table-top-bar${isLoading ? '-skeleton' : ''}`,
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle"
  }, hasFoldersTab && isListMode ? null : {
    borderInlineStartWidth: '100',
    borderInlineStartStyle: 'solid',
    borderInlineStartColor: 'border-core-subtle'
  }, hasFoldersTab && !isGalleryMode ? null : {
    borderInlineStartWidth: '100',
    borderInlineStartStyle: 'solid',
    borderInlineStartColor: 'border-core-subtle'
  }, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      gap: "250",
      backgroundColor: "fill-field-default",
      blockSize: `${TABLE_TOP_BAR_HEIGHT}px`,
      paddingBlock: "0",
      paddingInline: "100",
      children: content
    })
  }));
}